import React from "react";
import AppStoreButton from "assets/app-store/app-store.svg";
import GooglePlayButton from "assets/app-store/google-play.svg";
import { storeBeneficiarioButtonLink } from "utils/store-link";

export const AplicativosDownloadSection = () => {
  const link = storeBeneficiarioButtonLink();
  return (
    <>
      <h2 className="title text-blue font-weight-bold text-center text-md-left">
        Aplicativo do Paciente
      </h2>
      <h5 className="subtitle text-center text-md-left">
        Seus dados clínicos em suas mãos: o Aplicativo ProntLife Paciente é a
        ferramenta ideal para auxiliar o controle de sua saúde. Baixe
        gratuitamente!
      </h5>
      <div className="d-flex justify-content-center justify-content-md-start py-3">
        <a href={link.android} target="_blank" rel="noreferrer noopener">
          <img
            src={GooglePlayButton}
            className="rounded store-button"
            alt="Botão com link para download do aplicativo na Google Play"
          />
        </a>
        <a
          href={link.ios}
          target="_blank"
          rel="noreferrer noopener"
          className="px-2"
        >
          <img
            className="rounded store-button"
            src={AppStoreButton}
            alt="Botão com link para download do aplicativo na App Store"
          />
        </a>
      </div>
    </>
  );
};
